import React, { useState, useMemo } from 'react';
import { PieChart, Pie, Cell, Legend, ResponsiveContainer, Sector } from 'recharts';

const StatusDonutChart = ({ data, totalCount }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const total = useMemo(
        () => totalCount || (data || []).reduce((acc, cur) => acc + cur.value, 0),
        [data, totalCount]
    );

    const activeItem = activeIndex !== null && data && data[activeIndex] ? data[activeIndex] : null;

    const isEmpty = !data || data.length === 0;

    return (
        <div style={{ width: '100%', height: 420, position: 'relative' }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '1.1rem', fontWeight: 'var(--font-bold)', color: 'var(--text-primary)', letterSpacing: '0.5px' }}>
                Günlük Durum Dağılımı
            </h3>

            {isEmpty ? (
                <div className="flex items-center justify-center" style={{ height: '350px' }}>
                    <div className="text-secondary italic opacity-60" style={{ fontWeight: 'bold' }}>Veri Yok</div>
                </div>
            ) : (
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Legend
                            verticalAlign="bottom"
                            iconType="circle"
                            wrapperStyle={{ paddingTop: '10px' }}
                            formatter={(value, entry) => (
                                <span style={{ color: 'var(--text-secondary)', fontSize: '12px', marginLeft: '5px', fontWeight: 'bold' }}>
                                    {value} ({entry.payload.value})
                                </span>
                            )}
                        />
                        <Pie
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="40%"
                            innerRadius="55%"
                            outerRadius="75%"
                            paddingAngle={4}
                            cornerRadius={10}
                            stroke="var(--border-color)"
                            strokeWidth={1}
                            activeIndex={activeIndex}
                            labelLine={false}
                            label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
                                if (percent === 0) return null;
                                const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                                const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
                                const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
                                return (
                                    <text
                                        x={x}
                                        y={y}
                                        fill="white"
                                        textAnchor="middle"
                                        dominantBaseline="central"
                                        style={{ fontSize: '11px', fontWeight: 'bold', pointerEvents: 'none', textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}
                                    >
                                        {`${(percent * 100).toFixed(0)}%`}
                                    </text>
                                );
                            }}
                            activeShape={(props) => {
                                const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
                                return (
                                    <Sector
                                        cx={cx}
                                        cy={cy}
                                        innerRadius={innerRadius}
                                        outerRadius={outerRadius + 8}
                                        startAngle={startAngle}
                                        endAngle={endAngle}
                                        fill={fill}
                                        cornerRadius={12}
                                    />
                                );
                            }}
                            onMouseEnter={(_, index) => setActiveIndex(index)}
                            onMouseLeave={() => setActiveIndex(null)}
                        >
                            {data.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={entry.color}
                                    style={{ filter: `drop-shadow(0 0 8px ${entry.color}40)` }}
                                />
                            ))}
                        </Pie>

                        {/* Center Text: Total or Hovered Value */}
                        <text
                            x="50%"
                            y="40%"
                            textAnchor="middle"
                            dominantBaseline="central"
                            fill="var(--text-primary)"
                            style={{ fontSize: activeIndex !== null ? 24 : 36, fontWeight: 800 }}
                        >
                            {activeIndex !== null ? (activeItem ? `${Math.round((activeItem.value / total) * 100)}%` : "") : total}
                        </text>

                        {/* Center Sub-label */}
                        <text
                            x="50%"
                            y="49%"
                            textAnchor="middle"
                            dominantBaseline="central"
                            fill="var(--text-secondary)"
                            style={{ fontSize: 13, fontWeight: 'bold' }}
                        >
                            {activeIndex !== null ? (activeItem ? activeItem.name : "") : "Toplam Araç"}
                        </text>
                    </PieChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

export default StatusDonutChart;
